import { ADMIN } from 'components/RoleGate/constants';
import RoleModal from 'components/RoleModal';
import React from 'react';
import { Modal } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import { updateQueryString } from 'services/router/actions';
import NewOrganizationForm from './components/NewOrganizationForm';

export const NEW_ORGANIZATION_MODAL = 'NEW_ORGANIZATION_MODAL';

function NewOrganizationModal(): React.ReactElement {
    const dispatch = useDispatch();

    const handleOnClose = (): void => {
        dispatch(
            updateQueryString({
                [NEW_ORGANIZATION_MODAL]: undefined
            })
        );
    };

    return (
        <RoleModal
            param={NEW_ORGANIZATION_MODAL}
            requiredRoles={[ADMIN]}
            size="fullscreen"
        >
            <React.Fragment>
                <Modal.Header>New organization</Modal.Header>
                <Modal.Content className="constrain-width">
                    <NewOrganizationForm onClose={handleOnClose} />
                </Modal.Content>
            </React.Fragment>
        </RoleModal>
    );
}

export default NewOrganizationModal;
